import { Button } from '@mui/material'
import { useEffect, useState } from 'react'

import { FlexBox } from 'components/Box'
import Dialog from 'components/Dialog'
import { useDialogConfig } from './hooks/useDialogConfig'
import { useUploadAdUnitsConfiguration } from './hooks/useUploadAdUnitsConfiguration'
import { UploadDialogProps } from './types'

export const UploadDialog = ({
  domainId,
  hint,
  isOpen,
  setOpen,
  title,
  workspaceId,
}: UploadDialogProps): JSX.Element => {
  const [file, setFile] = useState<File>()
  const useUploadProps = useUploadAdUnitsConfiguration({ domainId, workspaceId })

  useEffect(() => {
    if (!isOpen) {
      useUploadProps.reset()
      setFile(undefined)
    }
  }, [isOpen])

  const {
    button: { action, disabled, title: buttonTitle },
    content,
  } = useDialogConfig({
    file,
    hint,
    setFile,
    setOpen,
    ...useUploadProps,
  })

  const Content: JSX.Element = <FlexBox axis='xy'>{content}</FlexBox>

  const Action: JSX.Element = (
    <Button
      data-cy={`upload-dialog-${buttonTitle.toLowerCase()}-button`}
      disabled={disabled || file === undefined}
      onClick={action}
      variant='contained'
    >
      {buttonTitle}
    </Button>
  )

  return (
    <Dialog
      actions={Action}
      content={Content}
      isOpen={isOpen}
      setOpen={setOpen}
      title={title}
    />
  )
}
